import { React, useContext } from 'react';
//import { AccordionComponent, AccordionItemDirective, AccordionItemsDirective } from '@syncfusion/ej2-react-navigations';
import './styles.css';
import P from 'prop-types';
import { GlobalContext } from '../../contexts/HomeContext';

const Atrasado = () => {
  return (
    <div className="texto-itens cardShadow" style={{ padding: 20, marginBottom: 15 }}>
      <h4>Esta Atrasado ?</h4>
      <p>
        Para saber se o seu pedido está atrasado, é preciso estar logado, e então verifique em &gt; Pedidos. Lá é
        possivel ver os status do seu pedido. Alguns pedidos podem vir a atrasar um pouco acima da previsão de entrega,
        devido a diversos fatores, mas não costumam ocorrer. Se o seu pedido estiver atrasado, você pode entrar em
        contato conosco, través de um dos nossos meios de contato, e esclareceremos acerca da previsão de entrega.
      </p>
    </div>
  );
};

const ChegouErrado = () => {
  return (
    <div className="texto-itens cardShadow" style={{ padding: 20, marginBottom: 15 }}>
      <h4>Chegou Errado ?</h4>
      <p>
        Se o seu pedido não chegou conforme você discriminou que devesse chegar, ou veio faltando algo. Desde já pedimos
        desculpas, e orientamos que entre em contato conosco, para que possamos solucionar o problema.
      </p>
    </div>
  );
};

const NaoFoiEntregue = () => {
  return (
    <div className="texto-itens cardShadow" style={{ padding: 20, marginBottom: 15 }}>
      <h4>Não foi Entregue?</h4>
      <p>
        Isso não é comum de ocorrer. E para termos certeza de que este é o caso, verifique os status do seu pedido e
        atente-se para os horários de cada etapa.Se achar melhor, sinta-se a vontade para entrar em contato conosco.
      </p>
    </div>
  );
};

const Cancelamento = () => {
  return (
    <div className="texto-itens cardShadow" style={{ padding: 20, marginBottom: 15 }}>
      <h4>Cancelamento</h4>
      <p>
        Sinceramente não esperamos que isso venha acontecer, mas se o seu desejo for o de cancelar o seu pedido, basta
        entrar em contato conosco solicitando o cancelamento.Caso o seu pedido conste como cancelado nos status. Isto é
        algo que não constumamos efetuar sem o concentimento do cliente, para tanto, entre em contato e as dúvidas
        poderão ser melhor esclarecidas.
      </p>
    </div>
  );
};

const Status = () => {
  return (
    <div className="texto-itens cardShadow" style={{ padding: 20, marginBottom: 15 }}>
      <h4>Status</h4>
      <p>
        A cada pedido realizado, você poderá acompanhar a situação dele em Meus Pedidos. Nesta área você terá acesso
        total aos seus pedidos, com todo o detalhamento dele, e assim você pode saber se o seu pedido ainda está em
        produção ou se já saiu para entrega. Caso exista alguma dúvida em relação a alguma etapa dos status, você pode
        tirar esta dúvida acessando o botão HELP, no canto superior direito da tela de status do pedido. Mas se preferir
        também pode entrar em contato direto conosco e esclareceremos suas dúvidas.
      </p>
    </div>
  );
};
const AlterarDados = () => {
  return (
    <div className="texto-itens cardShadow" style={{ padding: 20, marginBottom: 15 }}>
      <h4>Alterar Dados</h4>
      <p>
        Para alterar algum dado do seu perfil, basta acessar &gt; Meus Dados Será possivel alterar os seguintes dados:
        Nome e sobrenome, data de aniversário, telefone, endereço de entrega e a senha de acesso.
      </p>
    </div>
  );
};

const NotaFiscal = () => {
  return (
    <div className="texto-itens cardShadow" style={{ padding: 20, marginBottom: 15 }}>
      <h4>Nota Fiscal</h4>
      <p>
        A cada pedido feito, emitiremos a nota fiscal concernente ao mesmo. De modo que, você receberá a sua nota fiscal
        juntamente com o seu pedido, quando este for entregue. Vale lembrar que a nota fiscal será emitida no número do
        CPF informado no seu cadastro.
      </p>
    </div>
  );
};

const ComoPagar = () => {
  return (
    <div className="texto-itens cardShadow" style={{ padding: 20, marginBottom: 15 }}>
      <h4>Como Pagar</h4>
      <p>
        Efetuar o seu pagamento é muito simples. Quando já tiver escolhido os itens que deseja pedir, clique em &gt;
        Pagamento e então verifique se esta tudo ok com seu pedido, caso estaja tudo certo, clique em &gt; Pagamento.
        Então selecione a opcão de pagamento que melhor lhe servir.
      </p>
    </div>
  );
};

export const Ajuda = ({ handleModal }) => {
  const { dadosApp } = useContext(GlobalContext);
  return (
    <>
      <div className="container " style={{ margin: '25px 0px' }}>
        <Atrasado />
        <ChegouErrado />
        <NaoFoiEntregue />
        <Cancelamento />
        <Status />
        <AlterarDados />
        <NotaFiscal />
        <ComoPagar />
      </div>
      <div className="rodape-ajuda" style={{ marginBottom: 20 }}>
        <div>
          Sua dúvida não esta aqui?
          <br />
          Entre em contao conosco.{' '}
          <strong>
            <a onClick={() => handleModal('INFORMACOES', dadosApp.Empresa.Empresa.fantasia)}>Contato</a>
          </strong>
        </div>
      </div>
    </>
  );
};

Ajuda.propTypes = {
  handleModal: P.func,
  param: P.object,
};
